import {
  getEnabledTranslationLangs,
  getNormalizedTranslationLang
} from '../../../../../ui/src/providers/TranslationProvider/translation-flags'

export function getLanguageSwitcherTargets(currentLang: string | undefined, availableLangs: string[] | undefined) {
  const normalizedCurrentLang = getNormalizedTranslationLang(currentLang)
  const enabledLangs = getEnabledTranslationLangs(availableLangs)

  return [
    ...(normalizedCurrentLang === 'en' ? [] : (['en'] as const)),
    ...enabledLangs.filter((lang) => lang !== normalizedCurrentLang)
  ]
}
